import { COLORS } from '../constants';

export function AvatarIcon({ name, size = 40, color = COLORS.primary, emoji }) {
  return (
    <div style={{
      width: size, height: size, borderRadius: "50%",
      background: emoji ? `linear-gradient(135deg, ${color}22, ${color}44)` : `linear-gradient(135deg, ${color}, ${COLORS.primaryLighter})`,
      display: "flex", alignItems: "center", justifyContent: "center",
      color: emoji ? "unset" : "#fff", fontWeight: 700,
      fontSize: emoji ? size * 0.55 : size * 0.35,
      fontFamily: "Nunito, sans-serif", flexShrink: 0,
      border: `2px solid ${color}44`,
      boxShadow: `0 2px 8px ${color}30`
    }}>
      {emoji || name?.charAt(0)?.toUpperCase()}
    </div>
  );
}

export function Card({ children, style = {}, onClick }) {
  return (
    <div className="kid-ui-card" onClick={onClick} style={{
      background: COLORS.surface, borderRadius: 16,
      border: `1px solid ${COLORS.border}`,
      boxShadow: "0 2px 12px rgba(45,106,79,0.06)",
      padding: 20, transition: "all 0.2s",
      cursor: onClick ? "pointer" : "default", ...style
    }}>{children}</div>
  );
}

export function Button({ children, onClick, variant = "primary", size = "md", disabled = false, style = {} }) {
  const styles = {
    primary: { background: `linear-gradient(135deg, ${COLORS.primary}, ${COLORS.primaryLight})`, color: "#fff", border: "none", boxShadow: `0 4px 12px ${COLORS.primary}40` },
    secondary: { background: COLORS.surface, color: COLORS.primary, border: `2px solid ${COLORS.border}`, boxShadow: "none" },
    ghost: { background: "transparent", color: COLORS.primary, border: "none", boxShadow: "none" },
    danger: { background: "#FFF0F0", color: "#E63946", border: "1px solid #FFCDD2", boxShadow: "none" },
    success: { background: `linear-gradient(135deg, ${COLORS.success}, ${COLORS.primaryLight})`, color: "#fff", border: "none", boxShadow: `0 4px 12px ${COLORS.success}40` },
    kid: { background: `linear-gradient(135deg, #FFD93D, #FF9F1C)`, color: "#fff", border: "none", boxShadow: "0 4px 12px rgba(255,159,28,0.4)" },
  };
  const sizes = {
    sm: { padding: "6px 14px", fontSize: 12 },
    md: { padding: "10px 20px", fontSize: 14 },
    lg: { padding: "14px 28px", fontSize: 16 },
  };
  return (
    <button onClick={onClick} disabled={disabled} style={{
      ...styles[variant], ...sizes[size],
      borderRadius: 12, fontFamily: "Nunito, sans-serif", fontWeight: 800,
      cursor: disabled ? "not-allowed" : "pointer", opacity: disabled ? 0.6 : 1,
      transition: "all 0.2s", letterSpacing: 0.3, ...style
    }}>{children}</button>
  );
}

export function Input({ label, value, onChange, placeholder, type = "text" }) {
  return (
    <div style={{ marginBottom: 16 }}>
      {label && <div style={{ fontFamily: "Nunito, sans-serif", fontSize: 13, fontWeight: 700, color: COLORS.textMuted, marginBottom: 6 }}>{label}</div>}
      <input value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} type={type}
        style={{ width: "100%", padding: "10px 14px", borderRadius: 10, border: `2px solid ${COLORS.border}`, fontFamily: "Nunito, sans-serif", fontSize: 14, color: COLORS.text, background: COLORS.surfaceGreen, outline: "none", boxSizing: "border-box" }} />
    </div>
  );
}

export function Modal({ show, onClose, title, children }) {
  if (!show) return null;
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <div style={{ background: COLORS.surface, borderRadius: 20, padding: 28, width: "100%", maxWidth: 520, maxHeight: "85vh", overflowY: "auto", boxShadow: "0 20px 60px rgba(0,0,0,0.2)" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
          <div style={{ fontFamily: "Nunito, sans-serif", fontSize: 20, fontWeight: 800, color: COLORS.text }}>{title}</div>
          {onClose && <button onClick={onClose} style={{ background: COLORS.surfaceGreen, border: "none", borderRadius: 8, width: 32, height: 32, cursor: "pointer", fontSize: 16, color: COLORS.textMuted }}>✕</button>}
        </div>
        {children}
      </div>
    </div>
  );
}

export function Badge({ children, color = COLORS.accentLight, textColor = COLORS.primary }) {
  return (
    <span style={{ background: color, color: textColor, fontFamily: "Nunito, sans-serif", fontSize: 11, fontWeight: 700, padding: "3px 10px", borderRadius: 20 }}>{children}</span>
  );
}

export function StatCard({ label, value, emoji, color = COLORS.primary }) {
  return (
    <div className="kid-ui-statcard" style={{ background: `linear-gradient(135deg, ${COLORS.surfaceGreen}, ${COLORS.white})`, borderRadius: 16, border: `1px solid ${COLORS.border}`, padding: "18px 20px", textAlign: "center", boxShadow: "0 2px 12px rgba(45,106,79,0.06)" }}>
      <div style={{ fontSize: 28, marginBottom: 4 }}>{emoji}</div>
      <div style={{ fontFamily: "Nunito, sans-serif", fontSize: 28, fontWeight: 800, color }}>{value}</div>
      <div style={{ fontFamily: "Nunito, sans-serif", fontSize: 12, color: COLORS.textMuted, fontWeight: 600 }}>{label}</div>
    </div>
  );
}

export function Spinner() {
  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: 40 }}>
      <div style={{ width: 36, height: 36, border: `3px solid ${COLORS.accentLighter}`, borderTop: `3px solid ${COLORS.primary}`, borderRadius: "50%", animation: "spin 0.8s linear infinite" }} />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
